function alert_validation_messages (validation, first_line, last_line) {
	if (typeof validation !== "object") {
		return;
	}

	let message = first_line + "\n";
	for (let val in validation) {
		if (validation[val].length) {
			message += ["", ...validation[val]].join("\n • ");
		}
	}

	if (last_line) {
		message += "\n\n" + last_line;
	}

	alert(message);
}

export {alert_validation_messages};
